var ERREUR_FICHIER = Object.freeze({"type": 'type', "size": 'size'});

function initAceInputFile(obj, organisation, typeDocument) {
    if (obj.length == 0) {
        return;
    }

    if (typeof (typeDocument) == 'undefined') {
        var idSectionDocument = obj.closest('.champs-multiple').attr('id');
        if (idSectionDocument != undefined) {
            if (idSectionDocument.startsWith('b05-document')) typeDocument = 'photo';
            else if (idSectionDocument.startsWith('b06-document')) typeDocument = 'croquis';
            else if (idSectionDocument.startsWith('b90-document')) typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-permis') typeDocument = 'permis';
            else if (idSectionDocument === 'document-mutation') typeDocument = 'mutation';
            else if (idSectionDocument === 'document-operation-ue') typeDocument = 'operation-ue';
            else if (idSectionDocument === 'document-operation-cadastrale') typeDocument = 'operation-cadastrale';
            else if (idSectionDocument === 'document-correction-mineure-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-annulation-ue-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-actualisation-inventaire-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-enquete-vente-sous-bloc') typeDocument = 'autre-document'; //# 5874
            else if (idSectionDocument === 'document-changement-legislatif-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-changement-terrain-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-valeur-retenue-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-revision-recours-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-communication-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-mediane-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-demande-de-revision-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-correction-d-office-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-recours-au-tribunal-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-correction-erreur-ecriture-sous-bloc') typeDocument = 'autre-document';
            else if (idSectionDocument === 'document-enquete-revenu-sous-bloc') typeDocument = 'autre-document';
        }

        // pour les imports en lot
        if (obj.closest('[id^="b05-photo"]').length > 0) typeDocument = 'photo';
        else if (obj.closest('[id^="b90-autre-document"]').length > 0) typeDocument = 'autre-document';
        else if (obj.closest('#document-correction-mineure').length > 0) typeDocument = 'autre-document';
        else if (obj.closest('#document-annulation-ue').length > 0) typeDocument = 'autre-document';
        else if (obj.closest('#document-actualisation-inventaire').length > 0) typeDocument = 'autre-document';
        else if (obj.closest('#document-changement-legislatif').length > 0) typeDocument = 'autre-document';
        else if (obj.closest('#document-enquete-vente').length > 0) typeDocument = 'autre-document';
        else if (obj.closest('#document-valeur-retenue').length > 0) typeDocument = 'autre-document';
        else if (obj.closest('#document-revision-recours').length > 0) typeDocument = 'autre-document';
        else if (obj.closest('#document-changement-terrain').length > 0) typeDocument = 'autre-document';
        else if (obj.closest('#document-mediane').length > 0) typeDocument = 'autre-document';
    }

    var boolImportEnLot = false;
    var nomElementImportLot = null;

    if (typeof (obj.attr('lot-sous-bloc')) != 'undefined') {
        boolImportEnLot = true;
        nomElementImportLot = '#' + obj.attr('lot-sous-bloc');
    }

    var extensionsAutoriseesRegEx;
    if (typeDocument === 'croquis') {
        extensionsAutoriseesRegEx = RegExp('\\.(' + organisation.extensions_autorisees_croquis + ')$', 'i');
    } else if (typeDocument === 'photo') {
        extensionsAutoriseesRegEx = RegExp('\\.(' + organisation.extensions_autorisees_photos + ')$', 'i');
    } else if (typeDocument === 'permis' || typeDocument === 'mutation' ||
               typeDocument === 'operation-ue' || typeDocument === 'operation-cadastrale') {
        extensionsAutoriseesRegEx = /\.(pdf|xls|xlsx|doc|docx|jpe?g|gif|png|txt|bmp|tif?f|zip|jnt|msg)$/i;
    } else if (typeDocument === 'autre-document') {
        extensionsAutoriseesRegEx = /\.(pdf|xls|xlsx|xlsm|doc|docx|ods|jpe?g|gif|png|txt|bmp|tif?f|ax2|ax5|dxf|zip|jnt|msg)$/i;
    }

    var maxSize = 25000000; //25 MB

    // On gère nous-même le style des input files au lieu d'utiliser le plugin ace_file_input. Ce plugin venait définir un évènement "change" qui entre
    // en conflit avec celui définit par le plugin fileupload (fileuploadprocessalways)

    var noFileTexte = 'Choisir un fichier ...';
    if (!typeDocument.match("croquis|photo|autre-document")) {
        let filename = '';
        if (obj.attr('value') != undefined) {
            var filenameArr = (obj.attr('value').split('/'));
            filename = filenameArr[0];
            if (filenameArr.length > 1) filename = filenameArr[filenameArr.length - 1];
        }
        noFileTexte = filename;
    }

    var file_settings = {
        btn_choose: 'Choisir',
        btn_change: 'Modifier',
        no_file: noFileTexte,
        no_icon: 'fa fa-upload'
    };

    var filename;
    // On vient créer manuellement le html qui était généré normalement par le plugin ace_input_file afin de donner le bon style au input file
    if (!boolImportEnLot) {
        var parent_label = obj.closest('label').css({'display': 'block'});
        var tagName = parent_label.length === 0 ? 'label' : 'span'; // if not inside a "LABEL" tag, use "LABEL" tag, otherwise use "SPAN"
        obj.wrap('<' + tagName + ' class="ace-file-input" />');
        var icone = retournerIconeUpload(extensionsAutoriseesRegEx, file_settings);
        if (!typeDocument.match("autre-document")) { // ne pas afficher les noms de fichier car ils sont auto générés
            filename = obj.attr('value');
            obj.after('<span class="ace-file-container" data-title="' + file_settings.btn_choose + '"><span class="ace-file-name" data-title="' + (filename === undefined ? '' : filename) + '">' + (icone ? '<i class="ace-icon ' + icone + '"></i>' : '') + '</span></span>');
        } else { // afficher les noms de fichier
            $.each(obj, function (index, file) {
                filename = 'Choisir un fichier ...';
                if ($(this).attr('value') !== undefined && $(this).attr('value') !== "") {
                    var filenameArr = ($(this).attr('value').split('/'));
                    filename = filenameArr[0];
                    if (filenameArr.length > 1) {
                        filename = filenameArr[filenameArr.length - 1];
                        if (icone === 'fa fa-upload') {
                            file_settings.filename = filename;
                            icone = retournerIconeUpload(extensionsAutoriseesRegEx, file_settings);
                        }
                    }
                }
                $(this).after('<span class="ace-file-container" data-title="' + file_settings.btn_choose + '"><span class="ace-file-name" data-title="' + (filename === undefined ? '' : filename) + '">' + (icone ? '<i class="ace-icon ' + icone + '"></i>' : '') + '</span></span>');
            });
        }
    }
    $dropzonewizard = $(`#modal-wizard-evenement`)
    $($dropzonewizard).on('dragover drop', function (e) {
        e.preventDefault();
    });

    function triggerInputChangeSafely($input) {
        if ($input.data('triggering-change')) return;
        $input.data('triggering-change', true);
        setTimeout(() => {
            try {
                $input.trigger('change', {artificial: true});
            } finally {
                $input.removeData('triggering-change');
            }
        }, 0);
    }

    obj.fileupload({
        acceptFileTypes: extensionsAutoriseesRegEx,
        maxFileSize: maxSize,
        autoUpload: false,
        replaceFileInput: false,
        dropZone: obj.closest('.ace-file-input'),
        pasteZone: null
    })

        .on('fileuploaddrop', function (e, data) {
            if ($('body').hasClass('editeur-fiche')) return;
            const $input = $(this);
            $input.fileupload('add', {files: data.files, fileInput: $input});
            triggerInputChangeSafely($input);
        })

        .on('fileuploadadd', function (e, data) {
            if ($('body').hasClass('editeur-fiche')) return;
            const $input = $(data.fileInput);
            if ($input.length) {
                $.data($input[0], 'files', data.files);
                const $row = $input.closest('.sous-bloc-form');
                if ($row.length) $.data($row[0], 'files', data.files);
            }
        })

        .on('fileuploadprocessalways', function (e, data) {
            let $input = $(data.fileInput);
            let $container = $input.parent();

            if (boolImportEnLot) {
                const $lotInput = $(nomElementImportLot).find('.nouvelle-ligne input:file');
                $container = $lotInput.parent();
                $container.find('.ace-file-container').addClass('selected');

                const firstFile = (data.files && data.files[0]) ? [data.files[0]] : [];
                if (firstFile.length) {
                    $lotInput.fileupload('add', {files: firstFile, fileInput: $lotInput});
                    triggerInputChangeSafely($lotInput);
                }
                return;
            }

            $container.find('.ace-file-container')
                .attr('data-title', file_settings.btn_change)
                .addClass('selected');

            const currentFile = data.files[data.index];
            const leftIcon = $container.find('.ace-file-name');
            const filename = (typeof currentFile === 'string') ? currentFile : $.trim(currentFile.name);
            file_settings.filename = filename;
            leftIcon.attr({'data-title': filename});
            $container.closest('.sous-bloc-form').find('[name="nom_fichier_txt"]').val(filename);

            if (data.files.error && currentFile.error) {
                let error = '';
                if (currentFile.error == data.messages.acceptFileTypes) error = ERREUR_FICHIER.type;
                else if (currentFile.error == data.messages.maxFileSize) error = ERREUR_FICHIER.size;

                $input.addClass('error');
                leftIcon.find('i')
                    .removeClass()
                    .addClass('ace-icon fa fa-exclamation-triangle ace-error')
                    .attr('erreur', error);
            } else {
                const icone = retournerIconeUpload(extensionsAutoriseesRegEx, file_settings);
                const classes = 'ace-icon ' + icone + ' file-image';
                leftIcon.find('i').removeClass().addClass(classes);
                $input.removeClass('error');
            }

            // Garantir le signal "dirty" même si le flux n’a pas produit de change natif
            triggerInputChangeSafely($input);
        });

    const $dz = obj.closest('.ace-file-input').length ? obj.closest('.ace-file-input') : obj;

    $dz.on('dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
    }).on('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const dt = (e.originalEvent && e.originalEvent.dataTransfer) ? e.originalEvent.dataTransfer : e.dataTransfer;
        const files = dt && dt.files ? dt.files : null;
        if (files && files.length) {
            obj.fileupload('add', {files, fileInput: obj});
        }
    });
}


function retournerIconeUpload(extensionsAutoriseesRegEx, file_settings) {
    var liste_extensions_en_image = ICONES_EN_IMAGE;
    var recherche = (file_settings.filename !== undefined) ? file_settings.filename : file_settings.no_file;
    var extensionRegex = extensionsAutoriseesRegEx.exec(recherche);
    var icone;
    if (extensionRegex !== null) {
        var iconeMatch = extensionRegex[2];
        icone = 'fa fa-';
        if ($.inArray('.' + iconeMatch, liste_extensions_en_image) >= 0) {
            icone = icone + iconeMatch + '-evb';
        } else {
            icone = icone + 'flat-evb';
        }
    } else {
        icone = file_settings.no_icon;
    }

    return icone;
}

/**
 * Ajuster la taille de chacune des images.
 * @param {string} obj - Selecteur jQuery pointant sur une ou plusieurs images à traiter.
 */
function ajusterTailleImage(obj, myWidth, myHeight) {

    $.each(obj, function (idx, obj) {

        var img = $(obj)[0];
        //$("<img/>") // Make in memory copy of image to avoid css issues
        //.attr("src", $(img).attr("src"))

        $(img)
            .load(function () {
                var realWidth = this.width; // Note: $(this).width() will not
                var realHeight = this.height; // work for in memory images.
                //console.log(realWidth + '---' + realHeight);
                // on efface les données d'abord
                $(img).css('width', '').css('height', '');
                // On force un width ou height max sur le côté le plus grand pour s'assurer que toutes les images ont la même grandeur sans les déformer
                if (realWidth >= realHeight) $(img).width(myWidth);
                else $(img).height(myHeight);
            });
    });

}


function sauvegarderDocument(ligne, idBatiment, dateEvenement, idFormulaire, url, typeRequete, paramsOptionnels, callback, callbackError) {
    var inputFile = ligne.find('input:file');
    // On stop la sauvegarde si le input file n'est pas valide
    if (!inputFile.hasClass('error') || idFormulaire === -1) {

        var params = ligne.find('input, textarea, select').serializeArray();
        params = addParamsSuppPourInsertionArray(params, idBatiment, dateEvenement, idFormulaire);

        if (idFormulaire === -1) {
            // indiquer qu'on vient du mode assistant pour effectuer la validation
            params.push({name: 'wizard_mode', value: ''});
        } else if ($('#wizard').length > 0 && idFormulaire !== -1) {
            params.push({name: 'id_evenement', value: $('#wizard').attr('id-evenement')});
        }
        params.push({name: 'id_etape_processus', value: $('.step-pane.active').attr('data-id_processus')});

        $.each(paramsOptionnels, function (idx, item) {
            params.push(item);
        });

        // On vient définir dynamiquement certaines options pour le input file (déjà initialisé au chargement de la fiche ou ajout de ligne)
        inputFile.fileupload(
            'option', {
                type: typeRequete,
                formData: params,
                url: url,
                dataType: 'json',
                async: false,
                done: function (e, data) {
                    callback(data);
                    postSauvegardeDocument(ligne, data.result)
                },
                fail: function (e, data) {
                    console.log('fail');
                    console.log(e);
                    console.log(data);
                    callbackError(e, data);
                }
            }
        );

        var fileData = ligne.find('input:file');
        // On récupère l'objet file stocké dans le input lors de l'importation de photos en lot
        if (inputFile.val() === '') {

            fileData = $(inputFile.prop('fichier'));
            fileData.prop('name', 'nom');

        }

        (function () {
          let cachedFiles = $.data(inputFile[0], 'files');
          if ((!cachedFiles || !cachedFiles.length) && ligne && ligne[0]) {
            cachedFiles = $.data(ligne[0], 'files');
          }

          const hasNativeFile = inputFile[0].files && inputFile[0].files.length > 0;
          let sendArgs = null;

          if (cachedFiles && cachedFiles.length) {
            sendArgs = { files: cachedFiles };
          } else if (hasNativeFile) {
            sendArgs = { fileInput: inputFile };
          } else {
            const legacy = $(inputFile.prop('fichier'));
            if (legacy && legacy.length) {
              legacy.prop('name', 'nom');
              sendArgs = { fileInput: legacy };
            } else {
              console.warn('Aucun fichier sélectionné/déposé.');
              return;
            }
          }

          inputFile.fileupload('send', sendArgs);
        })();


    }

}

function addParamsSuppPourInsertionArray(params, idBatiment, dateEvenement, idFormulaire) {

    if (typeof (idBatiment) !== 'undefined') { // Il est possible d'ajouter un document à un permis sans avoir identifié l'ue.
        switch (idFormulaire) {
            default /* case ID_FORMULAIRE.residentiel*/
            :
                params.push({name: 'batiment', value: idBatiment});
                break;
            case -1: // cas provenant du wizard
            case ID_FORMULAIRE.terrainGeneral:
            case ID_FORMULAIRE.terrainAgricoleBoise:
            case ID_FORMULAIRE.renseignementAdministratif:
                params.push({name: 'uniteEvaluation', value: idBatiment});
                break;
        }
    }

    // Ajout du if pour gérer le cas de l'étape 1 du permis où l'on save un document sans date effective. La validation affiche un message de format de date alors qu'on veut plutôt un message qui dit de saisir d'abord la  date de prise d'effet au rôle
    //if (dateEvenement != '')
    params.push({name: 'date_debut', value: dateEvenement});

    return params;
}
